// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"6bce94c0","376":"0fc1ee82","453":"ad7ac691","652":"9714562b","708":"db910519","769":"af8ce986","789":"b28bd601","859":"a4b12497","945":"eff1a5da"}[chunkId] + ".chunk.js";
};